import { ImageType } from './files';

export const enum AttributeType {
  NUMERIC = 1,
  SELECT = 2,
  BOOLEAN = 3,
}

export interface Attributefullobject {
  id: number;
  type: number;
  type_name: string;
  name_en: string;
  name_ar: string;
  priority: number;
  category_name: string;
  category_id: number;
  custom: boolean;
  is_variable: boolean;
  hard_bottom_limit?: string;
  hard_upper_limit?: string;
  is_integer?: boolean;
  unit?: string;
  official_values?: string[] | boolean[];
  official_values_en?: string[];
  official_values_ar?: string[];
  values_images?: Valuesimagesitem[];
  values?: string[] | boolean[];
  values_en?: string[];
  values_ar?: string[];
}

export interface BaseAttribute {
  id: number;
  name_en: string;
  name_ar: string;
  type: string | number;
  is_variable: boolean;
  custom: boolean;
}
export interface BaseSelectAttribute extends BaseAttribute {
  type: AttributeType.SELECT;
  values_images: string[];
  official_values_en: string[];
  official_values_ar: string[];
  values_en: string[];
  values_ar: string[];
}
export interface BaseNumericAttribute extends BaseAttribute {
  type: AttributeType.NUMERIC;
  hard_bottom_limit: string;
  hard_upper_limit: string;
  values: string[];
  unit: string;
}

export interface BaseBooleanAttribute extends BaseAttribute {
  type: AttributeType.BOOLEAN;
  values: boolean[];
}

export interface Valuesimagesitem {
  value_en: string;
  value_ar: string;
  image?: ImageType;
  item_id: number;
}
